export const bannerImagesZapatos = [
    'https://relojes-s-l.s3.us-west-1.amazonaws.com/ROPA/Air+Force+1+x+Bape+azul.jpg',
    'https://relojes-s-l.s3.us-west-1.amazonaws.com/ROPA/Nike+AF1.jpeg',
    'https://relojes-s-l.s3.us-west-1.amazonaws.com/ROPA/Air+Force+1+x+Bape+verde.jpg'
]